import { Button, type ButtonProps } from '../Elements/Button';
import { useCRUDRefetch } from './CRUDForm';

export function CRUDRefetchButton(props: Omit<ButtonProps, 'onClickCapture'>) {
  const refetch = useCRUDRefetch();
  return <Button disabled={!refetch} onClickCapture={refetch} {...props} />;
}
